import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ExternalCrmLinksService } from '@nimbus-global/features/shared/services/domain/external-crm-links.service';

@Component({
  standalone: true,
  selector: 'nimbus-header-bar-help',
  templateUrl: './header-bar-help.component.html',
  styleUrl: './header-bar-help.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedUIModule, TranslateModule],
})
export class HeaderBarHelpComponent {
  public readonly ICONS = ICONS;
  public readonly TranslationKeys = TranslationKeys;

  public constructor(
    private readonly externalCrmLinksService: ExternalCrmLinksService,
    private readonly translateService: TranslateService,
  ) {}

  public openKnowledgeBase(): void {
    this.externalCrmLinksService.openLinks([this.translateService.instant(TranslationKeys.LinksLuwareGeneral)]);
  }
}
